<div class="contracts-list-wrapper-page">

  @if (loading === true) {
    <div class="loading-container">
      <p>Szerződések betöltése...</p>
    </div>
  } @else if (error && error.length > 0) {
    <div class="error-container">
      <p>{{ error }}</p>
      <button (click)="loadContracts()" class="retry-button">Újra próbálkozás</button>
    </div>
  } @else if (contracts && contracts.length > 0) {
    <!-- Filters Component -->
    <app-shared-filters 
      [pageName]="'contracts'"
      [initialFilter]="currentFilter"
      (filterChange)="onFilterChange($event)"
      (clearFilters)="onClearFilters()">
    </app-shared-filters>
    
    <!-- Contracts Table -->
    <app-contracts-list-table 
      [data]="filteredContracts" 
      title="Szerződések listája">
    </app-contracts-list-table>
  } @else {
    <div style="background: red; color: white; padding: 10px; margin: 10px 0;">
      <p>ELSE CASE: Loading = {{ loading }}, Error = "{{ error }}", Contracts = {{ contracts.length || 'undefined' }}</p>
    </div>
  }
</div>